'use client'

// The taco truck against the long tagged wall on the east side of town,
// beside the soup cart. Sam's model, 7 Oct: the stall, its awning, the
// spit, the stools and everything on the counter, laid out in Blender AT
// WORLD COORDINATES, so it renders at identity like the junk heap. The
// food you can see change as he eats is the counter's own (food_taco in
// the sim, drawn by FoodIndicators at the eatTaco spot in front of the
// stools), not this model.
//
// Moving the truck means moving it in Blender and re-exporting; where he
// stands to order is the eatTaco POI in sceneConfig, and its collision is
// obs_taco_stand in obstacles.glb.

import { useSceneNodeMaterials } from '../hooks/useSceneNodeMaterials'
import { useModel } from '../hooks/useModel'

const MODEL = '/models/tacoTruck.glb'

export function TacoTruck() {
  const { scene } = useModel(MODEL)

  useSceneNodeMaterials(scene, { roughness: 0.95 })

  // Baked transform: render at identity.
  return <primitive object={scene} />
}

export default TacoTruck
